import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { Key, Camera, ArrowLeft } from 'lucide-react';
import axios from 'axios';
import toast from 'react-hot-toast';
import { useAuthStore } from '../stores/authStore';

const ManualAuth = () => {
  const [oauthToken, setOauthToken] = useState('');
  const [oauthVerifier, setOauthVerifier] = useState('');
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();
  const { checkAuth } = useAuthStore();

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);

    try {
      const response = await axios.post('/api/auth/flickr/manual', {
        oauth_token: oauthToken,
        oauth_verifier: oauthVerifier
      }, {
        withCredentials: true
      });

      if (response.data.success) {
        toast.success('Authentication successful!');
        await checkAuth();
        navigate('/', { replace: true });
      }
    } catch (error) {
      console.error('Authentication error:', error);
      toast.error(error.response?.data?.error || 'Authentication failed');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen flex items-center justify-center bg-gray-50 py-12 px-4 sm:px-6 lg:px-8">
      <div className="max-w-md w-full space-y-8">
        <div>
          <div className="mx-auto h-12 w-12 flex items-center justify-center rounded-full bg-primary-100">
            <Key className="h-6 w-6 text-primary-600" />
          </div>
          <h2 className="mt-6 text-center text-3xl font-extrabold text-gray-900">
            Manual Authentication
          </h2>
          <p className="mt-2 text-center text-sm text-gray-600">
            Enter the OAuth codes from Flickr to complete authentication
          </p>
        </div>
        
        <div className="bg-white py-8 px-4 shadow sm:rounded-lg sm:px-10">
          <form className="space-y-6" onSubmit={handleSubmit}>
            <div>
              <label htmlFor="oauth_token" className="block text-sm font-medium text-gray-700">
                OAuth Token
              </label>
              <input
                id="oauth_token"
                name="oauth_token"
                type="text"
                required
                value={oauthToken}
                onChange={(e) => setOauthToken(e.target.value)}
                className="mt-1 input"
                placeholder="Enter the OAuth token from Flickr"
              />
            </div>

            <div>
              <label htmlFor="oauth_verifier" className="block text-sm font-medium text-gray-700">
                OAuth Verifier
              </label>
              <input
                id="oauth_verifier"
                name="oauth_verifier"
                type="text"
                required
                value={oauthVerifier}
                onChange={(e) => setOauthVerifier(e.target.value)}
                className="mt-1 input"
                placeholder="Enter the OAuth verifier from Flickr"
              />
            </div>

            <div>
              <button
                type="submit"
                disabled={loading}
                className="w-full flex justify-center items-center py-2 px-4 border border-transparent rounded-md shadow-sm text-sm font-medium text-white bg-primary-600 hover:bg-primary-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-primary-500 disabled:opacity-50 disabled:cursor-not-allowed"
              >
                {loading ? 'Authenticating...' : 'Complete Authentication'}
              </button>
            </div>
          </form>
          
          <div className="mt-6">
            <div className="relative">
              <div className="absolute inset-0 flex items-center">
                <div className="w-full border-t border-gray-300" />
              </div>
              <div className="relative flex justify-center text-sm">
                <span className="px-2 bg-white text-gray-500">Or</span>
              </div>
            </div>
            
            <div className="mt-6">
              <button
                onClick={() => navigate('/login')}
                className="w-full flex justify-center items-center py-2 px-4 border border-gray-300 rounded-md shadow-sm text-sm font-medium text-gray-700 bg-white hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-primary-500"
              >
                <ArrowLeft className="mr-2 h-4 w-4" />
                Back to Login
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ManualAuth;
